@if (isPolicyViewEnabled && showPolicyView) {
  <app-policy-view-wrapper
    [policyView]="policyView"
    [theme]="theme"
    (eventTriggered)="onAction($event)"
  ></app-policy-view-wrapper>
} @else {
  <div class="main">
    @if (!policy) {
      <ds-localized-spinner
        [dataLoading]="!policy"
        [loadingMessage]="'Looking for policy details...'"
      >
      </ds-localized-spinner>
    }
    @if (policy) {
      <div>
        <div class="pad-bottom-30 jump-links-wrapper">
          <ds-jump-links [jumpLinks]="jumpLinks"></ds-jump-links>
        </div>
        <div class="new-risk-card">
          <auto-risk-card
            [isConnectPartner]="isConnectPartner"
            [multipleVehicle]="multipleVehicle"
            [vehicleId]="selectedVehicle.vehicleId"
          >
          </auto-risk-card>
        </div>
        <div class="row pad-top-20 pad-bottom-20">
          <div class="image-container">
            <img src="/assets/images/Risk_info_card_foodle.svg" />
          </div>
          @if (showCoveragesCard) {
            <div class="view-coverge-details-wrapper">
              <button (click)="onCoverageDetailsClicked()">
                <div>View Coverage Details</div>
                <img src="/assets/images/doodle-arrow.svg" alt="View Coverage Details" />
              </button>
            </div>
          }
          <div class="simple-cards">
            <div class="left">
              <div class="margin-bottom-20">
                <ds-simple-card
                  headerIcon="dollar-sign_doodle.svg"
                  heading="Premium"
                  [buttons]="premiumActionButtons"
                  id="premiumCard"
                >
                  <policy-discounts
                    [vehicleId]="selectedVehicleId"
                    [policy]="policy"
                  ></policy-discounts>
                </ds-simple-card>
              </div>
              <div>
                <ds-simple-card
                  headerIcon="Icon_Keys.svg"
                  heading="People Covered"
                  [buttons]="peopleCoveredActionButtons"
                  [showFooter]="!isConnectPartner"
                  id="peopleCoveredCard"
                >
                  @if (nameInsured) {
                    <ds-key-value-card
                      classes="pad-bottom-20"
                      [key]="nameInsuredHeading"
                      [value]="nameInsured"
                      [tooltipTemplateRef]="nameInsuredRef"
                    ></ds-key-value-card>
                  }
                  @if (listedDrivers) {
                    <ds-key-value-card
                      classes="pad-bottom-20"
                      [key]="listedDriversHeading"
                      [value]="listedDrivers"
                      [tooltipTemplateRef]="listedDriverRef"
                    ></ds-key-value-card>
                  }
                  @if (nonDrivers) {
                    <ds-key-value-card
                      classes="pad-bottom-20"
                      key="Non-Driver"
                      [value]="nonDrivers"
                      [tooltipTemplateRef]="nonDriverRef"
                    ></ds-key-value-card>
                  }
                </ds-simple-card>
              </div>
            </div>
            <div class="right">
              @if (showCoveragesCard) {
                <ds-simple-card
                  headerIcon="coverage.svg"
                  heading="Coverage for My Vehicle"
                  [buttons]="coverageActionButtons"
                  [showFooter]="!(isFutureDatedPolicy && isConnectPartner)"
                  id="coveragesCard"
                >
                  <app-coverages
                    [newAFITemplate]="true"
                    [policy]="policy"
                    [vehicleId]="selectedVehicleId"
                    (show)="showCoverages($event)"
                  ></app-coverages>
                </ds-simple-card>
              }
            </div>
          </div>
        </div>
        <div class="new-documents" id="documentsCard" isRendered (iAmReady)="gotodocuments()">
          <policy-documents
            [documents]="policyDocuments | async"
            [startDate]="policy.periodStartDate"
            [endDate]="policy.periodEndDate"
            [cancelDate]="policy.cancelDate"
            [hasCancelDate]="hasCancelDate"
          ></policy-documents>
        </div>
        <div class="policy-footer">
          <span
            *dsPartnerAFI
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'agent' }"
            data-cy="detailFooterTextAgent"
          ></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterText'"
            [options]="{ name: 'representative' }"
            data-cy="detailFooterTextRepresentative"
          ></span>
          <span
            *dsPartnerAFI
            dsContent
            [contentPath]="'policyDetail.detailFooterTextAFI'"
            data-cy="detailFooterTextAFI"
          ></span>
          <span
            *dsPartnerConnect
            dsContent
            [contentPath]="'policyDetail.detailFooterTextPartner'"
            data-cy="detailFooterTextPartner"
          ></span>
        </div>
      </div>
    }
  </div>
  <ng-template #nameInsuredRef>
    <div class="tooltip-content-wrapper">
      <ds-content-wrapper context="nameinsured"></ds-content-wrapper>
    </div>
  </ng-template>

  <ng-template #listedDriverRef>
    <div class="tooltip-content-wrapper">
      <ds-content-wrapper context="listeddriver"></ds-content-wrapper>
    </div>
  </ng-template>

  <ng-template #nonDriverRef>
    <div class="tooltip-content-wrapper">
      <ds-content-wrapper context="nondriver"></ds-content-wrapper>
    </div>
  </ng-template>
}
